// 다국어 번역 시스템
const translations = {
  ko: {
    // 공통
    common: {
      home: 'HOME',
      about: 'ABOUT',
      lab: 'LAB',
      contact: '연락처',
      socialMedia: '소셜 미디어',
      viewMore: '더 보기',
      loading: '로딩 중...',
      error: '오류가 발생했습니다.',
      success: '성공!',
      cancel: '취소',
      confirm: '확인',
      save: '저장',
      delete: '삭제',
      edit: '편집',
      add: '추가',
      search: '검색',
      filter: '필터',
      sort: '정렬',
      refresh: '새로고침',
      close: '닫기',
      back: '뒤로',
      next: '다음',
      previous: '이전',
      submit: '제출',
      reset: '초기화',
      copy: '복사',
      copied: '복사됨',
      clickToCopy: '클릭하여 복사',
      language: '언어',
      theme: '테마',
      settings: '설정',
      preferences: '선호사항',
      darkMode: '다크 모드',
      lightMode: '라이트 모드',
      changeLanguage: '언어 변경',
      menu: '메뉴'
    },

    // 헤더
    header: {
      companyName: 'AI-LABC',
      companySubtitle: 'AI 솔루션 전문 기업',
      navigation: {
        home: 'HOME',
        about: 'ABOUT',
        lab: 'LAB'
      }
    },

    // 푸터
    footer: {
      description: '혁신적인 AI 솔루션으로 미래를 만들어갑니다.',
      contact: '연락처',
      socialMedia: '소셜 미디어',
      address: '서울특별시 강남구 테헤란로 123'
    },

    // 홈페이지
    home: {
      title: 'AI-LABC의 혁신적인 프로젝트들',
      subtitle: '최신 AI 기술을 활용한 다양한 산업 분야의 솔루션들을 확인해보세요.',
      targetMarkets: '주요 타겟',
      roles: {
        fullStackSolo: '풀스택 개발자 (솔로)',
        aiEngineer: 'AI 엔지니어',
        aiResearcher: 'AI 연구원',
        frontendDeveloper: '프론트엔드 개발자',
        backendDeveloper: '백엔드 개발자',
        fullStackDeveloper: '풀스택 개발자'
      }
    },

    // 회사 소개
    about: {
      title: 'AI-LABC 소개',
      subtitle: '혁신적인 AI 솔루션으로 미래를 만들어갑니다',
  description: 'AI-LABC는 최신 인공지능 기술을 활용하여 다양한 산업 분야의 문제를 해결하는 전문 기업입니다. 우리는 고객의 비즈니스 성장과 디지털 혁신을 위해 끊임없이 연구하고 개발하고 있습니다.',
      mission: '최첨단 AI 기술을 통해 고객의 비즈니스 가치를 극대화하고, 사회에 긍정적인 영향을 미치는 혁신적인 솔루션을 제공합니다.',
      vision: 'AI 기술의 민주화를 통해 모든 기업이 혁신적인 디지털 전환을 경험할 수 있는 세상을 만듭니다.',
      stats: {
        founded: '2020년 설립',
        employees: '50+ 전문가',
        projects: '100+ 프로젝트',
        clients: '200+ 고객사',
        awards: '15+ 수상'
      },
      services: {
        title: '주요 서비스',
        aiDevelopment: {
          title: 'AI 솔루션 개발',
          description: '머신러닝, 딥러닝, 자연어 처리 등 최신 AI 기술을 활용한 맞춤형 솔루션을 개발합니다.'
        },
        dataAnalysis: {
          title: '데이터 분석 및 인사이트',
          description: '대용량 데이터를 분석하여 비즈니스에 가치 있는 인사이트를 도출합니다.'
        },
        aiConsulting: {
          title: 'AI 컨설팅',
          description: 'AI 도입 전략 수립부터 구현까지 전 과정을 지원하는 전문 컨설팅을 제공합니다.'
        },
        cloudAI: {
          title: '클라우드 AI 서비스',
          description: 'AWS, Azure, GCP 등 주요 클라우드 플랫폼에서 AI 서비스를 구축하고 운영합니다.'
        }
      }
    },

    // 연구실
    lab: {
      title: 'AI-LABC Lab',
      subtitle: '혁신적인 AI 연구와 개발의 실험실',
  description: 'AI-LABC Lab은 최신 AI 기술을 연구하고 실험하는 공간입니다. 여기서는 새로운 아이디어를 테스트하고, 혁신적인 솔루션을 개발하며, AI의 미래를 탐구합니다.',
      comingSoonMessage: '곧 새로운 포트폴리오와 프로젝트들이 추가될 예정입니다.',
      features: {
        aiResearch: {
          title: 'AI 연구',
          description: '최신 AI 알고리즘과 모델을 연구하고 실험합니다.'
        },
        prototyping: {
          title: '프로토타입 개발',
          description: '새로운 아이디어를 빠르게 프로토타입으로 구현합니다.'
        },
        innovation: {
          title: '혁신 실험',
          description: 'AI 기술의 새로운 응용 분야를 탐구합니다.'
        }
      },
      currentProjects: '현재 진행 중인 프로젝트',
      youtubePlayer: {
        title: 'YouTube 플레이리스트 플레이어',
        description: 'AI 기반 음악 추천과 함께하는 스마트 플레이어',
        category: '음악',
        type: '플레이어',
        status: 'AI 분석'
      },
      comingSoon: {
        title: '곧 새로운 콘텐츠가 추가됩니다',
        portfolio: '포트폴리오 프로젝트',
        research: 'AI 연구 결과',
        blog: '기술 블로그'
      }
    },

    // YouTube 플레이어
    youtubePlayer: {
      title: '🎵 YouTube 플레이리스트 플레이어',
  subtitle: 'URL을 붙여넣으면 바로 재생되는 AI-LABC Lab의 음악 플레이어',
      inputPanel: {
        title: '🎵 YouTube 플레이리스트 붙여넣기 → 바로 재생',
        placeholder: 'YouTube 플레이리스트 URL을 붙여넣으세요',
        loadButton: '불러오기',
        demoButton: '데모',
        tip: '예시: https://www.youtube.com/playlist?list=PL...'
      },
      history: {
        title: '재생 히스토리',
        clearButton: '히스토리 초기화',
        clearConfirm: '정말로 히스토리를 초기화하시겠습니까?',
        noHistory: '아직 재생 기록이 없습니다.'
      },
      audio: {
        toggle: '오디오 토글',
        on: '오디오 켜기',
        off: '오디오 끄기',
        tip: '클릭하여 오디오를 켜세요'
      }
    },

    // AI 추천
    aiRecommendation: {
      title: '🎵 AI 음악 분석 & 추천',
      startAnalysis: '분석 시작',
      analyzing: '분석 중...',
      advancedAnalysis: '고급 분석',
      advancedAnalysisTooltip: '플레이리스트의 실제 곡 정보를 분석하여 더 정확한 결과를 제공합니다',
      preferences: {
        title: '선호사항 설정',
        mood: {
          label: '선호 분위기:',
          options: {
            chill: '차분한',
            energetic: '활기찬',
            romantic: '로맨틱',
            focused: '집중',
            party: '파티'
          }
        },
        activity: {
          label: '활동:',
          options: {
            general: '일반',
            workout: '운동',
            study: '공부',
            sleep: '수면'
          }
        }
      },
      loading: 'AI가 음악을 분석하고 있습니다...',
      analysis: {
        title: '🎯 음악 취향 분석',
        noHistory: '💡 아직 플레이리스트 히스토리가 없어서 일반적인 음악 취향을 기반으로 추천드립니다. YouTube 플레이리스트를 재생하시면 더 정확한 분석을 받으실 수 있습니다!',
        tags: {
          genres: '🎵 선호 장르 & 🌙 분위기 & 💡 추천 키워드',
          insight: '💭 AI의 분석 의견'
        }
      },
      recommendations: {
        currentSong: '🎵 현재 곡 기반 추천',
        aiGenerated: '🤖 AI 생성 플레이리스트',
        popular: '🎵 인기 플레이리스트 추천',
        songCount: '곡',
        newAnalysis: '새로운 분석 받기'
      },
      errors: {
        noApiKey: 'OpenAI API 키가 설정되지 않았습니다.',
        analysisFailed: 'AI 분석 중 오류가 발생했습니다.',
        recommendationFailed: 'AI 추천을 가져오는 중 오류가 발생했습니다.',
        noRecommendations: '새로운 추천을 찾을 수 없습니다.'
      }
    }
  },

  en: {
    // Common
    common: {
      home: 'HOME',
      about: 'ABOUT',
      lab: 'LAB',
      contact: 'Contact',
      socialMedia: 'Social Media',
      viewMore: 'View More',
      loading: 'Loading...',
      error: 'An error occurred.',
      success: 'Success!',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      refresh: 'Refresh',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      reset: 'Reset',
      copy: 'Copy',
      copied: 'Copied',
      clickToCopy: 'Click to copy',
      language: 'Language',
      theme: 'Theme',
      settings: 'Settings',
      preferences: 'Preferences',
      darkMode: 'Dark Mode',
      lightMode: 'Light Mode',
      changeLanguage: 'Change Language',
      menu: 'Menu'
    },

    // Header
    header: {
      companyName: 'AI-LABC',
      companySubtitle: 'AI Solutions Company',
      navigation: {
        home: 'HOME',
        about: 'ABOUT',
        lab: 'LAB'
      }
    },

    // Footer
    footer: {
      description: 'Creating the future with innovative AI solutions.',
      contact: 'Contact',
      socialMedia: 'Social Media',
      address: '123 Teheran-ro, Gangnam-gu, Seoul'
    },

    // Home
    home: {
      title: 'Innovative Projects by AI-LABC',
      subtitle: 'Discover solutions across various industries powered by cutting-edge AI technology.',
      targetMarkets: 'Target Markets',
      roles: {
        fullStackSolo: 'Full-Stack Developer (Solo)',
        aiEngineer: 'AI Engineer',
        aiResearcher: 'AI Researcher',
        frontendDeveloper: 'Frontend Developer',
        backendDeveloper: 'Backend Developer',
        fullStackDeveloper: 'Full-Stack Developer'
      }
    },

    // About
    about: {
      title: 'About AI-LABC',
      subtitle: 'Creating the future with innovative AI solutions',
  description: 'AI-LABC is a specialized company that solves problems across various industries using cutting-edge artificial intelligence technology. We continuously research and develop to drive customer business growth and digital innovation.',
      mission: 'We maximize customer business value through state-of-the-art AI technology and provide innovative solutions that create positive social impact.',
      vision: 'We create a world where all companies can experience innovative digital transformation through the democratization of AI technology.',
      stats: {
        founded: 'Founded in 2020',
        employees: '50+ Experts',
        projects: '100+ Projects',
        clients: '200+ Clients',
        awards: '15+ Awards'
      },
      services: {
        title: 'Our Services',
        aiDevelopment: {
          title: 'AI Solution Development',
          description: 'Develop customized solutions using cutting-edge AI technologies including machine learning, deep learning, and natural language processing.'
        },
        dataAnalysis: {
          title: 'Data Analysis & Insights',
          description: 'Analyze large-scale data to derive valuable business insights.'
        },
        aiConsulting: {
          title: 'AI Consulting',
          description: 'Provide specialized consulting supporting the entire process from AI adoption strategy to implementation.'
        },
        cloudAI: {
          title: 'Cloud AI Services',
          description: 'Build and operate AI services on major cloud platforms including AWS, Azure, and GCP.'
        }
      }
    },

    // Lab
    lab: {
      title: 'AI-LABC Lab',
      subtitle: 'Laboratory for innovative AI research and development',
  description: 'AI-LABC Lab is a space for researching and experimenting with the latest AI technologies. Here, we test new ideas, develop innovative solutions, and explore the future of AI.',
      comingSoonMessage: 'New portfolio projects and content will be added soon.',
      features: {
        aiResearch: {
          title: 'AI Research',
          description: 'Research and experiment with the latest AI algorithms and models.'
        },
        prototyping: {
          title: 'Prototype Development',
          description: 'Quickly implement new ideas as prototypes.'
        },
        innovation: {
          title: 'Innovation Experiments',
          description: 'Explore new applications of AI technology.'
        }
      },
      currentProjects: 'Current Projects',
      youtubePlayer: {
        title: 'YouTube Playlist Player',
        description: 'Smart player with AI-based music recommendations',
        category: 'Music',
        type: 'Player',
        status: 'AI Analysis'
      },
      comingSoon: {
        title: 'New Content Coming Soon',
        portfolio: 'Portfolio Projects',
        research: 'AI Research Results',
        blog: 'Tech Blog'
      }
    },

    // YouTube Player
    youtubePlayer: {
      title: '🎵 YouTube Playlist Player',
      subtitle: 'AI-LABC Lab\'s music player that plays immediately when you paste a URL',
      inputPanel: {
        title: '🎵 Paste YouTube Playlist → Play Immediately',
        placeholder: 'Paste YouTube playlist URL here',
        loadButton: 'Load',
        demoButton: 'Demo',
        tip: 'Example: https://www.youtube.com/playlist?list=PL...'
      },
      history: {
        title: 'Play History',
        clearButton: 'Clear History',
        clearConfirm: 'Are you sure you want to clear the history?',
        noHistory: 'No play history yet.'
      },
      audio: {
        toggle: 'Audio Toggle',
        on: 'Audio On',
        off: 'Audio Off',
        tip: 'Click to enable audio'
      }
    },

    // AI Recommendation
    aiRecommendation: {
      title: '🎵 AI Music Analysis & Recommendations',
      startAnalysis: 'Start Analysis',
      analyzing: 'Analyzing...',
      advancedAnalysis: 'Advanced Analysis',
      advancedAnalysisTooltip: 'Analyze actual song information in playlists for more accurate results',
      preferences: {
        title: 'Preferences',
        mood: {
          label: 'Preferred Mood:',
          options: {
            chill: 'Chill',
            energetic: 'Energetic',
            romantic: 'Romantic',
            focused: 'Focused',
            party: 'Party'
          }
        },
        activity: {
          label: 'Activity:',
          options: {
            general: 'General',
            workout: 'Workout',
            study: 'Study',
            sleep: 'Sleep'
          }
        }
      },
      loading: 'AI is analyzing your music...',
      analysis: {
        title: '🎯 Music Taste Analysis',
        noHistory: "💡 No playlist history yet, so we're providing recommendations based on general preferences. Play YouTube playlists to get more accurate analysis!",
        tags: {
          genres: '🎵 Preferred Genres & 🌙 Mood & 💡 Recommended Keywords',
          insight: '💭 AI Analysis Insight'
        }
      },
      recommendations: {
        currentSong: '🎵 Based on Current Song',
        aiGenerated: '🤖 AI Generated Playlists',
        popular: '🎵 Popular Playlist Recommendations',
        songCount: 'songs',
        newAnalysis: 'Get New Analysis'
      },
      errors: {
        noApiKey: 'OpenAI API key is not configured.',
        analysisFailed: 'An error occurred during AI analysis.',
        recommendationFailed: 'An error occurred while fetching AI recommendations.',
        noRecommendations: 'No new recommendations found.'
      }
    }
  }
};

// 번역 함수
export const t = (key, language = 'ko', params = {}) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      console.warn(`Translation key not found: ${key} for language: ${language}`);
      return key; // 키가 없으면 키 자체를 반환
    }
  }
  
  if (typeof value === 'string') {
    // 파라미터 치환
    return value.replace(/\{(\w+)\}/g, (match, param) => {
      return params[param] !== undefined ? params[param] : match;
    });
  }
  
  return value;
};

// 지원 언어 목록
export const supportedLanguages = [
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' }
];

// 언어 코드 유효성 검사
export const isValidLanguage = (code) => {
  return supportedLanguages.some(lang => lang.code === code);
};

// 기본 언어
export const defaultLanguage = 'ko';

export default translations;
